import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

function BarChartFrequency({ height = 260, data = [], loading }) {
    const { t } = useTranslation()

    const showLoading = useMemo(() => loading || !data.average, [loading, data])

    const total = useMemo(() => Object.keys(data.frequency).reduce((sum, key) => sum + (data.frequency[key] || 0), 0), [data])

    const maxValue = useMemo(() => Math.max(...Object.keys(data.frequency).map((key) => data.frequency[key])), [data])

    const roundUpToNextTwenty = (n) => Math.max(20, Math.ceil(n / 20) * 20)
    const maxScopeValue = roundUpToNextTwenty(maxValue * 1.1)

    return (
        <div className={showLoading ? 'blur' : ''}>
            <div className="flex flex-row mt-5 w-full pb-[20px]" style={{ minHeight: height }}>
                <div className="flex items-center justify-center w-5" style={{ minHeight: height }}>
                    <p className="text-[#464554] text-[12px] leading-5 font-normal" style={{ writingMode: 'vertical-rl', transform: 'rotate(180deg)' }}>
                        {t('Number of students')}
                    </p>
                </div>

                <div className="min-w-[30px] relative z-[1]">
                    <div className="flex flex-col-reverse gap-[1px] justify-between h-full min-w-[30px]">
                        {Array.from({ length: 5 }, (_, i) => i).map((item, index) => (
                            <div key={index} className="flex flex-col w-full" style={{ minHeight: 20 }}>
                                <p className="text-[12px] leading-5 text-darkenPurple font-medium text-end">{(maxScopeValue * item) / 4}</p>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="flex-1 relative ml-[10px]" style={{ scrollbarColor: '#9392AD transparent' }}>
                    <div className="h-full py-[9px]" style={{ minWidth: '100%' }}>
                        <div className="flex flex-col items-center w-full gap-[1px] h-full justify-between" style={{ minHeight: height }}>
                            {Array.from({ length: 5 }, (_, i) => i).map((_, index) => (
                                <div
                                    key={index}
                                    className={`${index === 4 ? 'border-b border-b-[#B7B3E5]' : 'border-b border-dashed border-b-[#ECEBF8]'} w-full`}
                                    style={{ height: 1 }}
                                />
                            ))}
                        </div>
                    </div>

                    <div className="flex flex-row items-end absolute top-0 left-0 z-[3] w-full justify-between py-[8px] gap-[14px] px-[20px]">
                        {Object.keys(data.frequency).map((item, index) => (
                            <BarChartItem key={index} height={height} item={data.frequency[item]} maxValue={maxScopeValue} total={total} index={index} label={item} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BarChartFrequency

const BarChartItem = ({ height, item, maxValue, index, total, label }) => {
    const { t } = useTranslation()

    const percentage = (item / (maxValue || 1)) * 100
    const studentCount = Math.round(item)
    const percentageOfTotal = Math.round((item / total) * 100)

    return (
        <div className="w-[120px] max-w-[120px] relative flex-1" style={{ marginLeft: index === 0 ? 40 : 0 }}>
            <div className="w-full flex flex-col justify-end relative" style={{ minHeight: height, height }}>
                <div
                    className="rounded-t-[4px] rounded-b-[2px] min-h-[5px] relative transition-all duration-[0.5s]"
                    style={{
                        backgroundColor: '#DFDDF3',
                        height: `${percentage}%`,
                        backgroundImage: 'linear-gradient(-45deg, #5E639B 12%, transparent 12%, transparent 50%, #5E639B 50%, #5E639B 62%, transparent 25%, transparent)',
                        backgroundSize: '10px 10px',
                    }}
                >
                    <div className="absolute -top-5 w-full flex items-center justify-center">
                        <p className="font-semibold leading-5 text-[10px] xl:text-[12px] transition-all" style={{ color: '#413F5E' }}>
                            {studentCount} {studentCount === 1 ? t('student') : t('students')}
                            <span className="font-medium" style={{ color: '#6D699B' }}>
                                ({percentageOfTotal}%)
                            </span>
                        </p>
                    </div>
                </div>
            </div>

            <div className="w-full flex flex-row justify-center mt-[3px]">
                <p className="flex-1 text-[12px] leading-5 font-bold transition-all duration-500 text-center text-[#484856] h-5">{label ?? ''} check-ins</p>
            </div>
        </div>
    )
}
